<cll-card class="app-pagination-card"
          *ngIf="context$ | async as context">
    <div class="card-content">

        <div class="results">
            <p *ngIf="context.length">
                Total: {{ context.length }}
            </p>

            <p>
                Per page:

                <mat-select
                    [(value)]="context.pageSize"
                    data-testid="dropdown:page-size"
                    (valueChange)="changePageSize($event)">
                    <mat-option
                        *ngFor="let pageSizeOption of pageSizeOptions"
                        [attr.data-testid]="pageSizeOption"
                        [value]="pageSizeOption">
                        {{ pageSizeOption }}
                    </mat-option>
                </mat-select>
            </p>

            <ng-content select="[resultsEnd]"></ng-content>
        </div>

        <ng-content />

        <div class="paging">
            <button cll-icon-button
                    [disabled]="context.pageIndex === 0"
                    (click)="setPage(context.pageIndex - 1)">
                <cll-icon>chevron_left</cll-icon>
            </button>

            <button class="page-select"
                    #pageSelect="matMenuTrigger"
                    data-testid="info:pages-count"
                    [class.clickable]="context.length > 0"
                    [matMenuTriggerFor]="context.length ? pageMenu : null"
                    [disabled]="context.length <= 1">
                Page {{ context.pageIndex + 1 }}
                <ng-container *ngIf="context.length">
                    of {{ (context.pagesCount) || 1 }}
                </ng-container>
            </button>

            <button cll-icon-button
                    [disabled]="(context.pageIndex + 1) * (context.pageSize) >= context.length"
                    (click)="setPage(context.pageIndex + 1)">
                <cll-icon data-testid="icon:chevron-right">chevron_right</cll-icon>
            </button>

            <mat-menu #pageMenu="matMenu">
                <ng-template matMenuContent>
                    <ng-container *ngIf="pageOptions$ | async as pages">
                        <button *ngFor="let page of pages"
                                mat-menu-item
                                (click)="setPage(page.index)"
                                [disabled]="page.index === context.pageIndex">
                            Page {{ page.label }}
                        </button>
                    </ng-container>

                    <ng-container *ngIf="context.pagesCount > 10">
                        <div class="paginator__goto-page"
                             (click)="$event.preventDefault(); $event.stopImmediatePropagation()">
                            <input type="number"
                                   #input
                                   placeholder="Go to page"
                                   min="0"
                                   step="1"
                                   (keyup)="_onGoToKeyUp($event, pageSelect)">

                            <cll-icon *ngIf="input.value"
                                      cllRipple
                                      (click)="goToPage(input, pageSelect)">
                                check
                            </cll-icon>
                        </div>
                    </ng-container>
                </ng-template>
            </mat-menu>
        </div>
    </div>
</cll-card>
